import React from 'react';
import './App.css';
import Portofolio from './componnetns/porto.jsx';

function App() {
  return (
    <Portofolio />
  );
}

export default App;
